<template>
  <van-nav-bar :title="title" left-arrow>
    <template #left>
      <div class="flex items-center" @click="router.back()">
        <van-icon name="arrow-left" size="20px" color="#666" />
      </div>
    </template>
  </van-nav-bar>
</template>

<script lang="ts" name="v-nav-bar" setup>
  import { useIonRouter } from '@ionic/vue';
  const router = useIonRouter()
  defineProps({
    title: String
  })
  const onClickLeft = () => {
    router.back()
  }
</script>

<style>
</style>